import IconVideo from './component.jsx'
export default IconVideo
